//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'
import footerNav from '@/components/footerNav'

export default {
  name: "createNoTest",
  components: {
    footerNav
  },
  data() {
    return {
      switchChecked:true,
      switchChecked1:true,
      switchChecked2:true,
      switchChecked3:true,
      switchChecked4:true,
      switchChecked5:true,
      switchChecked6:true,
      value: '',
      columns: ['抽检', '全检', '免检'],
      showPicker: false,
      reasonList:[]
    }
  },
  activated() {
    if(this.$route.params&&this.$route.params.data){
      this.reasonList = this.reasonList.concat(this.$route.params.data)
    }else{
      this.value = '';
      this.reasonList=[];
    }
  },
  created(){
    // if(this.$route.params&&this.$route.params.data){
    //   this.reasonList = this.reasonList.concat(this.$route.params.data)
    // }
  },
  mounted() {
  },
  methods: {
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    toAddReason(){
      this.$router.push({name:'addReason',type:1})
    },
    confirm(){

    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/sendOrder/createNoTest.vue